import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { OrderFacade } from './+state';
import { OrderStateModule } from './+state/order.state.module';

import {
  OrderService
} from './services';

@NgModule({
  imports: [CommonModule, OrderStateModule],
})
export class DomainOrderModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainOrderModule,
      providers: [
        OrderService,
        OrderFacade
      ],
    };
  }
}
